import React from "react";
import { Button, Typography, Modal } from "../../core";
import { Row } from "antd";

const DeleteModals = ({
  deleteModalsOpen,
  closeModal,
  headerTittle,
  confirmDeleteHandler,
  ...props
}) => {
  return (
    <Modal
      closable={true}
      footer={false}
      visible={deleteModalsOpen}
      // onCreate={onCreate}
      maxwidth="568px"
      onCancel={() => closeModal("deleteConfirmModal")}
      tittle={headerTittle || "Are you sure to Delete"}
    >
      <Row tyep="flex" justify="space-between">
        <Button bg="#233B67" width="100px">
          <Typography
            as="h5"
            align="center"
            weight="bold"
            noMargin
            color="white"
            onClick={() => closeModal("deleteConfirmModal")}
          >
            Cancel
          </Typography>
        </Button>
        <Button bg="#233B67" width="100px" onClick={confirmDeleteHandler}>
          <Typography
            as="h5"
            align="center"
            weight="bold"
            noMargin
            color="white"
          >
            Confirm
          </Typography>
        </Button>
      </Row>
    </Modal>
  );
};

export default DeleteModals;
